import Hero from '../components/Hero'
import Fleet from '../components/Fleet'
import HowItWorks from '../components/HowItWorks'
import Rates from '../components/Rates'
import Coverage from '../components/Coverage'
import ContactForm from '../components/ContactForm'

export default function Home() {
  return (
    <>
      <Hero />
      <Fleet />
      <HowItWorks />
      <Rates />
      <Coverage />
      <ContactForm />
    </>
  )
}
